"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import PersonaCard from "./PersonaCard";

const PersonaCarousal = ({
    personas,
    iscontentPreview,
    heading,
    parentCategory,
    subCategory
}: any) => {
    return (
        <div className="advice-course-container">
            <div className="advice-inner-wrap">
                <div className="slider-container">
                    <Swiper
                        pagination={{ clickable: true }}
                        navigation={true}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 8,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                        }}
                        modules={[FreeMode, Pagination, Navigation]}
                        className="MultiSwiper"
                    >
                        {personas?.map((persona: any, index: number) => (
                            <SwiperSlide className="!h-auto" key={index + 1}>
                                <PersonaCard
                                    jsondata={persona}
                                    index={index}
                                    iscontentPreview={iscontentPreview}
                                    heading={heading}
                                    parentCategory={parentCategory}
                                    subCategory={subCategory}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default PersonaCarousal;
